var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 17.3327C4.39734 17.3327 0.666504 13.6018 0.666504 8.99935C0.666504 4.39685 4.39734 0.666016 8.99984 0.666016C13.6023 0.666016 17.3332 4.39685 17.3332 8.99935C17.3332 13.6018 13.6023 17.3327 8.99984 17.3327ZM8.99984 15.666C10.7679 15.666 12.4636 14.9636 13.7139 13.7134C14.9641 12.4632 15.6665 10.7675 15.6665 8.99935C15.6665 7.23124 14.9641 5.53555 13.7139 4.2853C12.4636 3.03506 10.7679 2.33268 8.99984 2.33268C7.23173 2.33268 5.53604 3.03506 4.28579 4.2853C3.03555 5.53555 2.33317 7.23124 2.33317 8.99935C2.33317 10.7675 3.03555 12.4632 4.28579 13.7134C5.53604 14.9636 7.23173 15.666 8.99984 15.666ZM8.1665 4.83268H9.83317V6.49935H8.1665V4.83268ZM8.1665 8.16602H9.83317V13.166H8.1665V8.16602Z",
    fill: "#1D2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.053470922f351f256e64ea005c929ead.svg";
export { ForwardRef as ReactComponent };